<template>
  <request :method="request.method" :params="request.params" #default="{ loading, error }" v-model="response">
    <content-spinner v-if="loading" class="ma3"/>
    <div v-else-if="error" class="ma3">Ошибка: {{ error }}</div>
    <div v-else-if="comments && comments.length > 0" class="entity-details-layout entity-details-layout-list">
      <icon-in-circle class="entity-details-icon">
        <font-awesome-icon :icon="['far', 'comment']"/>
      </icon-in-circle>
      <div class="entity-details-header pv3 pv4-l ph3 ph1-l">
        <span class="db ttu f6 fw6 entity-secondary">Комментарии</span>
      </div>
      <div class="entity-details-content list-grid ml4-l bt b--near-white bw1">
        <comment v-for="(item, index) in comments" :key="index" class="list-item">
          <template slot="author">{{ item.managerName }}</template>
          <template slot="comment">{{ item.comment }}</template>
          <template slot="datetime">{{ formatDateTime(item.datetime) }}</template>
        </comment>
      </div>
    </div>
    <div v-else class="ph3 pv4 entity-secondary">
      Комментариев нет
    </div>
  </request>
</template>

<script>
import Request from '@/components/Request.vue'
import ContentSpinner from '@/components/common/ContentSpinner.vue'
import IconInCircle from '@/components/ui/IconInCircle.vue'
import Comment from '@/components/common/Comment.vue'
import { momentFromString } from '@/utils/datetime.js'

export default {
  props: ['claim'],
  components: {
    IconInCircle,
    Request,
    ContentSpinner,
    Comment
  },
  computed: {
    comments () {
      return this.response.claimComments.map((comment, i) => ({
        id: i,
        manager_id: comment.userId,
        managerName: comment.userName,
        comment: comment.comment,
        datetime: comment.date
      }))
    }
  },
  data () {
    return {
      request: {
        method: 'getClaimDetails',
        params: {
          claimId: this.claim.id
        }
      },
      response: null
    }
  },
  methods: {
    formatDateTime (datetime) {
      return momentFromString(datetime)?.format('DD.MM.YYYY hh:mm')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
